// extracted by mini-css-extract-plugin
export default {"logotypeWrapper":"KA5ad","logo":"od5Fd","logoBy":"tjEfh","logoKz":"WjrO9","logoUz":"xXY0t"};